export default __webpack_public_path__ + "3f2eefce8ac8d4b1ab963e1394290da0.woff";